<template>
  <div class="carousel">
    <div class="carousel-items">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="carousel-item"
        :class="{ active: currentIndex === index }"
      >
        <img :src="item.imageUrl" alt="">
        <div class="text-block">
            <div class="carouse-title wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.2s">{{ item.title }}</div>
            <div class="carousel-desc wow fadeInUp" data-wow-delay="0.5s">{{ item.desc }}</div>
        </div>
      </div>
    </div>
    <div class="carousel-indicators">
      <div class="indicator">
        <div
          class="indicator-bar"
          :class="{
            'active-1': currentIndex === 0,
            'active-2': currentIndex === 1,
            'active-3': currentIndex === 2,
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";

export default {
  data() {
    return {
      currentIndex: 0,
      items: [
        { imageUrl: 'https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/index/index_banner1.png', title: "专注于新能源场景的技术研发和应用",desc:"助力光伏行业实现降本增效，推动新能源行业高质量发展" },
        { imageUrl: 'https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/index/index_banner2.png', title: "用户至上 追求卓越",desc:"User First Pursuing Excellence" },
        { imageUrl: 'https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/index/index_banner3.png', title: "用科技推动发展 以创新引领未来",desc:"Promoting Development with Technology and Leading the Future with Innovation" },
      ],
      intervalId: null,
    };
  },
  mounted() {
    this.startAutoplay();
    this.$nextTick(() => {
      new WOW().init();
    });
  },
  beforeDestroy() {
    this.stopAutoplay();
  },
  methods: {
    startAutoplay() {
      this.intervalId = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.items.length;
        new WOW().init();
      }, 4000);
    },
    stopAutoplay() {
      clearInterval(this.intervalId);
    },
  },
};
</script>

<style  lang="stylus" scoped>
.carousel {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  .carousel-inner {
  position: relative;
  width: 100%;
  height: 100%;
}

.carousel-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
  display:flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color:#fff;
  .text-block {
    position:absolute;
    .carouse-title {
        font-size: 3.75rem;
        font-weight:bold;
        letter-spacing:2px;
        margin-bottom:2.75rem;
    }
    .carousel-desc {
        font-size:2rem;
        }
  }
}

.carousel-item.active {
  opacity: 1;
}

.carousel-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel-indicators {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.indicator {
  width: 300px;
  height: 1px;
  background: rgba(255,255,255,0.5);;
  display: flex;
}

.indicator-bar {
  width: 100px;
  height: 2px;
  margin-top:-1px;
  background: #FFFFFF;
}

.indicator-bar.active-1 {
    transform: translateX(0);
}
.indicator-bar.active-2 {
    transform: translateX(100px);
}
.indicator-bar.active-3 {
    transform: translateX(200px);
}
}
@media only screen and (max-width: 1200px) and (min-width: 768px) {
  .carousel {
    height:35.125rem !important;
    .text-block {
      width:60%;
      white-space:wrap;
      .carouse-title {
        font-size:2rem !important;
        margin-bottom:1.55rem !important;
        letter-spacing:1px !important;
      }
      .carousel-desc {
        font-size:1.125rem !important;
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .carousel {
    height:50vh !important;
    margin-top:57px;
    .text-block {
      white-space:wrap;
      width:60%;
      .carouse-title {
        font-size:2rem !important;
        margin-bottom:1.55rem !important;
      }
      .carousel-desc {
        font-size:1.125rem !important;
      }
    }
  }
}

</style>
